// test2486
(2486 && 0);
